import { useState } from 'react';
import { DistributionBar } from '../DistributionBar.tsx';
import { Select } from '../ui.tsx';
import type { PerDimensionDistributionRow } from '../types.ts';

// View 4 — pick a dimension, see the 1..5 stacked distribution (counts + %).
export function DimensionDistributionView({
  data,
  colors,
}: {
  data: PerDimensionDistributionRow[];
  colors: readonly string[];
}) {
  const [slug, setSlug] = useState<string>('');
  const active = data.find((d) => d.slug === slug) ?? data[0];

  if (!active) {
    return <p className="text-sm text-ink-soft">No dimensions available.</p>;
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="max-w-xs">
        <Select
          id="dim-dist-select"
          label="Dimension"
          value={active.slug}
          onChange={setSlug}
          options={data.map((d) => ({ value: d.slug, label: d.name }))}
        />
      </div>
      <DistributionBar distribution={active.distribution} colors={colors} />
    </div>
  );
}
